import { Component, Input, OnInit } from '@angular/core';
import { TitleLineConfigurations } from '../title/title.configurations';
import { GraphData } from './shared/donut-graph-data';
import { KlaDataService } from '../services/kla.data.service';
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { ActionPlanProgressChartDonutGraphComponent } from './shared/action-plan-progress-chart-donut-graph/action-plan-progress-chart-donut-graph.component';

@Component({
  selector: 'kla-action-plan-progress-chart',
  templateUrl: './action-plan-progress-chart.component.html',
  styleUrls: ['./action-plan-progress-chart.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, ActionPlanProgressChartDonutGraphComponent ]
})
export class ActionPlanProgressChartComponent implements OnInit {
  @Input() lineConfig: TitleLineConfigurations;
  @Input() config: any;

  pages;

  graphData: GraphData[];

  constructor(private dataService: KlaDataService) {}

  get includedTaxonomies() {
    return this.config?.taxonomies;
  }

  get imagePosition() {
    return this.config?.imagePosition;
  }

  ngOnInit(): void {
    this.pages = this.dataService.getData().default ? this.dataService.getData().default.pages : this.dataService.getData().pages;
    this.getTaxonomiesConfig(this.pages);
  }

  getTaxonomiesConfig(pages) {
    const statuses = [];
    
      for (const page of pages) {
        if (
        page.layout.includes('custom')
        ) {
          for (const pack of page.details.packages) {
            for (const subPack of pack.subPackages) {
              for (const component of subPack?.components) {
                if (
                  component.component === 'kla-action-taxonomy' ||
                  (component.component === 'new-action-taxonomy' &&
                    component.isVisible)
                ) {
                  if (
                    component.component === 'new-action-taxonomy' &&
                    this.includedTaxonomies.includes(component.id)
                  ) {
                    for (const category of component.configurations.list) {
                      if (category.isVisible) {
                        for (const goal of category.list) {
                          if (goal?.strategies && goal?.strategies?.length > 0) {
                            for (const strategy of goal?.strategies) {
                              for (const action of strategy.list) {
                                statuses.push(
                                  action.status?.value || action.status?.title
                                );
                              }
                            }
                          } else {
                            for (const action of goal?.actions) {
                              statuses.push(
                                action.status?.value || action.status?.title
                              );
                            }
                          }
                        }
                      }
                    }
                  }
                  if (
                    component.component === 'kla-action-taxonomy' &&
                    this.includedTaxonomies.includes(component.id)
                  ) {
                    for (const category of component.configurations.list) {
                      if (category.isVisible) {
                        for (const goal of category.list) {
                          if (goal.include.title == 'Strategies') {
                            for (const strategy of goal?.list) {
                              for (const action of strategy.list) {
                                statuses.push(
                                  action.status?.value || action.status?.title
                                );
                              }
                            }
                          } else {
                            for (const action of goal.list) {
                              statuses.push(
                                action.status?.value || action.status?.title
                              );
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
      }
    }
    this.mapStatusesForGraph(statuses);
  }

  mapStatusesForGraph(statuses) {
    let counts = {
      Complete: { count: 0, color: '#35c13b' },
      'Awaiting Resources': { count: 0, color: '#ffce00' },
      'In Progress': { count: 0, color: '#2492d6' },
      Paused: { count: 0, color: '#ed30ae' },
      'Not Started': { count: 0, color: '#1d455e' },
      Ongoing: { count: 0, color: '#f08f20' },
    };

    // Count occurrences of each status
    statuses.forEach((status) => {
      if (status === 'Complete') {
        counts['Complete'].count++;
      } else if (status === 'Awaiting Resources' || !status) {
        counts['Awaiting Resources'].count++;
      } else if (status === 'In Progress') {
        counts['In Progress'].count++;
      } else if (status === 'Ongoing' || !status) {
        counts['Ongoing'].count++;
      } else if (status === 'Paused') {
        counts['Paused'].count++;
      } else if (status === 'Not Started') {
        counts['Not Started'].count++;
      }
    });

    // Calculate total count of all statuses
    const totalCount = Object.values(counts).reduce(
      (acc, { count }) => acc + count,
      0
    );

    // Calculate percentages and update counts
    Object.keys(counts).forEach((status) => {
      counts[status].percentage =
        (counts[status].count / totalCount) * 100 || 0;
    });

    // Prepare result
    let result = [];
    Object.keys(counts).forEach((status) => {
      result.push({
        title: status,
        count: counts[status].count,
        percentage: counts[status].percentage.toFixed(2),
        color: counts[status].color,
      });
    });

    this.graphData = result;
  }
}
